var exports = {
  "jl": "flash__9sHSUI",
  "i4": "warningText__3dkp5G",
  "AH": "queryHelp__4cR8wo",
  "UX": "suggestionWrapper__lFGQ-p",
  "_T": "suggestionText__70a7E8",
  "gO": "monoLink__KPeZBe",
};

module.exports = exports;
